

function border_in_pourcentage_direction(_id, _direction, _int) {
	var el = $(_id);
	var w = el.width() / 2 | 0; // calculate & trim decimals
	el.css("border-"+_direction+"-width", w + "px");
}
function border_in_pourcentage(_id, _int) {
	var el = $(_id);
	var w = el.width() / _int | 0; // calculate & trim decimals
	el.css("border-width", w + "px");
}

border_in_pourcentage_direction("#b", "right", 2);
border_in_pourcentage_direction("#c", "right", 2);
border_in_pourcentage_direction("#d", "left", 2);
border_in_pourcentage_direction("#e", "left", 2);